// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/arrow-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/arrow-up.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.risk-screening {
  color: #fff;
  background-color: #050e25;
  height: 100vh;
  width: 100%;
  margin: 0px;
  padding: 0px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px; }
  .risk-screening .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center; }
  .risk-screening h2 {
    font-weight: 600; }
  .risk-screening .header-options-container {
    width: auto;
    display: flex; }
  .risk-screening .expand-container {
    position: absolute;
    top: 65px;
    left: 70px;
    height: 90vh !important;
    width: calc(100% - 100px) !important;
    z-index: 100; }
  .risk-screening .expand-container .table-container {
    max-height: 80vh !important; }
  .risk-screening .fullscreen,
  .risk-screening .more-options {
    background-color: unset;
    border: unset; }
    .risk-screening .fullscreen img,
    .risk-screening .more-options img {
      filter: invert(1); }
  .risk-screening .fullscreen:hover {
    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%); }
  .risk-screening .more-options:hover {
    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%); }
  .risk-screening .container-row-top {
    min-height: 40vh;
    margin-top: 5px; }
  .risk-screening .container-row-bottom {
    min-height: 40vh;
    margin-top: 1px; }
  .risk-screening .column-chart {
    margin-left: 10px;
    max-width: 40%; }
  .risk-screening .chart-container {
    height: 100%;
    width: 100%;
    width: -webkit-fill-available;
    width: -moz-available;
    width: stretch;
    max-height: 50vh; }
  .risk-screening .chart-container-parent {
    margin-left: 10px; }
  .risk-screening .chart-container {
    position: relative;
    background-color: #0b1736;
    border-radius: 2px;
    box-shadow: 0px 0px 20px #000; }
  .risk-screening .expand-chart-container {
    position: absolute !important;
    top: 60px;
    left: 95px;
    height: 94vh !important;
    width: 94% !important;
    z-index: 100;
    max-height: 94vh; }
  .risk-screening .map-report-container {
    background-color: #0b1736;
    border-radius: 2px;
    box-shadow: 0px 0px 20px #000;
    display: flex;
    position: relative;
    height: 100%; }
  .risk-screening .column-summary {
    min-width: 120px; }
  .risk-screening .summary-container {
    background-color: #0b1736;
    border-radius: 2px;
    box-shadow: 0px 0px 20px #000;
    display: flex;
    margin-top: 0px;
    margin-left: 0px;
    padding-top: 0px;
    height: 24vh;
    width: 120px;
    min-width: 120px;
    overflow-x: hidden;
    overflow-y: auto;
    flex-direction: column;
    border-radius: 7px;
    max-height: 24vh; }
  .risk-screening .summary-container-secondary {
    margin-top: 20px; }
  .risk-screening .summary-title {
    display: flex;
    width: 110px;
    white-space: break-spaces;
    text-align: center;
    margin-bottom: 1px; }
  .risk-screening .summary-title Button {
    display: none;
    margin-left: 15px;
    background-color: #fff;
    border: unset; }
  .risk-screening .summary-title img {
    vertical-align: unset !important; }
  .risk-screening .summary-title Button:hover {
    background-color: #257ee0; }
  .risk-screening .summary-button {
    display: none;
    width: 44px;
    display: inline-flex;
    align-self: flex-end;
    background-color: white; }
  .risk-screening .card {
    padding-left: 2px;
    width: 120px;
    line-height: 18px;
    padding-top: 5px;
    margin-bottom: 10px;
    max-width: 110px;
    border-radius: 2px; }
  .risk-screening .card-header {
    height: 37px; }
  .risk-screening .card-title {
    line-height: 5px;
    font-size: 1.2rem; }
  .risk-screening .card-body {
    padding: .2rem; }
  .risk-screening .summary-container-span {
    font-size: 1.2rem; }
  .risk-screening .te-primary {
    background-color: #050e25; }
  .risk-screening .te-secondary {
    background-color: #4fc32c; }
  .risk-screening .te-blue {
    background-color: #0b61bf; }
  .risk-screening .summary-top {
    width: 100px; }
  .risk-screening .summary-field-name {
    font-size: 12px;
    color: gray;
    padding-bottom: 5px; }
  .risk-screening .summary-field-double {
    height: auto;
    line-height: 18px; }
  .risk-screening .summary-field-highlight {
    color: #49b4cd; }
  .risk-screening .mapboxgl-popup-content {
    padding: 0px !important;
    opacity: .95;
    border-radius: 4px;
    width: 100% !important;
    background-color: #18244c; }
  .risk-screening .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
    border-bottom-color: #050E25;
    opacity: .8; }
  .risk-screening .mapboxgl-popup-close-button {
    display: none; }
  .risk-screening .popup-container {
    background-color: black;
    opacity: .95;
    text-align: center;
    height: 220px;
    padding-top: 14px;
    padding-bottom: 32px;
    padding-left: 10px;
    padding-right: 4px;
    font-size: 14px;
    font-size: 14px;
    min-width: 210px;
    line-height: 10px;
    font-family: "Urbanist";
    background-color: #050E25;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: max-content; }
  .risk-screening .popup-content-left {
    text-align: right;
    margin-right: 10px;
    width: 75px;
    white-space: normal; }
  .risk-screening .popup-content-right {
    text-align: left;
    width: 200px; }
  .risk-screening .popup-content-right-double {
    height: 32px;
    line-height: 18px;
    margin-bottom: 25px; }
  .risk-screening .map-title {
    width: auto;
    white-space: nowrap;
    position: absolute;
    left: 50px;
    top: 0px;
    font-size: 1.25rem;
    padding: 5px;
    z-index: 90; }
  .risk-screening .map-legend {
    width: 180px;
    min-height: auto;
    position: absolute;
    border-radius: 5px;
    padding: 5px;
    right: 30px;
    bottom: 10px;
    background-color: #18244c;
    z-index: 90; }
  .risk-screening .map-legend p {
    margin-left: 5px;
    height: 10px; }
  .risk-screening .map-legend span {
    width: 100px;
    margin-left: 5px; }
  .risk-screening .map-legend-dot {
    background-color: #4b5ea6;
    height: 14px;
    width: 14px;
    margin-left: 5px;
    border-radius: 5%;
    display: inline-flex;
    color: #86b7fe; }
  .risk-screening .map-legend-accordion-header button {
    border: 0px !important; }
  .risk-screening .accordion-button {
    color: white;
    background-color: #18244c;
    border: 0px !important; }
  .risk-screening .accordion-button::after {
    border: 0px !important;
    filter: invert(100%); }
  .risk-screening .fullscreen:hover {
    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%); }
  .risk-screening .more-options:hover {
    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%); }
  .risk-screening .attribution-textbox {
    margin-top: 3px;
    font-size: 1rem;
    text-align: end; }
  .risk-screening .line-chart {
    height: 100%; }
  .risk-screening .line-chart canvas {
    height: 100%; }
  .risk-screening .report-options-table {
    width: 'auto';
    margin-left: 10px;
    height: 35px; }
  .risk-screening .report-options-table button {
    position: absolute;
    right: 30px; }
  .risk-screening .report-options-table-title {
    text-align: left;
    font-weight: 500;
    vertical-align: sub;
    font-size: 1rem; }
  .risk-screening .table-parent-container {
    margin-left: 10px !important;
    width: 100%; }
  .risk-screening .table-container {
    background-color: #0b1736;
    border-radius: 2px;
    box-shadow: 0px 0px 20px #000;
    display: flex;
    position: relative;
    margin-top: 10px;
    max-height: 36vh;
    overflow-y: auto;
    height: -webkit-fill-available;
    height: fill-available; }
  .risk-screening .reportTable {
    min-height: 10vh;
    color: white; }
  .risk-screening .table-parent-container {
    background-color: #0b1736;
    border-radius: 2px;
    box-shadow: 0px 0px 20px #000;
    margin-top: 10px;
    overflow-x: hidden;
    margin-left: 20px;
    overflow-y: hidden;
    height: 40vh; }
    .risk-screening .table-parent-container table {
      color: #fff;
      font-size: 1.2vw;
      border: unset;
      overflow-y: auto; }
      .risk-screening .table-parent-container table td,
      .risk-screening .table-parent-container table tr,
      .risk-screening .table-parent-container table th,
      .risk-screening .table-parent-container table thead,
      .risk-screening .table-parent-container table tbody {
        font-weight: unset;
        border: unset;
        font-size: 1.2vw; }
      .risk-screening .table-parent-container table thead > tr > :nth-child(1) {
        border-bottom: 0.5px solid #222224;
        border-right: 0.5px solid #222224; }
      .risk-screening .table-parent-container table thead > tr > th:not(:first-child) {
        border-bottom: 0.5px solid #222224;
        border-left: 0.5px solid #222224; }
      .risk-screening .table-parent-container table tbody > tr > td:not(:first-child) {
        border-left: 0.5px solid #222224; }
      .risk-screening .table-parent-container table tbody > tr:hover {
        background-color: #021d3e;
        cursor: pointer; }
      .risk-screening .table-parent-container table tbody > tr > td.principal {
        border-top: 0.5px solid #222224; }
      .risk-screening .table-parent-container table .sub > td:nth-child(1) {
        padding-left: 30px; }
      .risk-screening .table-parent-container table .principal {
        background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
        background-repeat: no-repeat;
        background-position: right 10px top 14px; }
      .risk-screening .table-parent-container table .principal.active {
        color: #4fc2d9;
        background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
        background-repeat: no-repeat;
        background-position: right 10px top 14px; }
  .risk-screening .report-options {
    margin-top: 2px;
    text-align: right;
    margin-right: 10px; }
    .risk-screening .report-options button {
      border: unset;
      margin-left: 10px; }
    .risk-screening .report-options .btn-light:hover {
      background-color: #257ee0; }
  .risk-screening .report-chart-options {
    margin-top: 2px;
    text-align: right;
    margin-right: 2px;
    position: absolute;
    top: 10px;
    right: 10px; }
    .risk-screening .report-chart-options button {
      background-color: #fff;
      border: unset;
      margin-left: 410px; }
    .risk-screening .report-chart-options .btn-light:hover {
      background-color: #257ee0; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/reports/RiskScreening/styles.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACdrD;EACE,WDVqB;ECWrB,yBDEsC;ECDtC,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAdoB;EAepB,mBAfoB;EAgBpB,iBAfmB,EAAA;EAMrB;IAYI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB,EAAA;EAdvB;IAkBI,gBAAgB,EAAA;EAlBpB;IAsBI,WAAW;IACX,aAAa,EAAA;EAvBjB;IA2BI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,oCAAoC;IACpC,YAAY,EAAA;EAhChB;IAoCI,2BAA2B,EAAA;EApC/B;;IAyCI,uBAAuB;IACvB,aAAa,EAAA;IA1CjB;;MA6CM,iBAAiB,EAAA;EA7CvB;IAkDI,iGAAiG,EAAA;EAlDrG;IAsDI,iGAAiG,EAAA;EAtDrG;IA0DI,gBAAgB;IAChB,eAAe,EAAA;EA3DnB;IA+DI,gBAAgB;IAChB,eAAe,EAAA;EAhEnB;IAoEI,iBAAiB;IACjB,cAAc,EAAA;EArElB;IAyEI,YAAY;IACZ,WAAW;IAEX,6BAA6B;IAC7B,qBAAc;IAAd,cAAc;IACd,gBAAgB,EAAA;EA9EpB;IAkFI,iBAAiB,EAAA;EAlFrB;IAsFI,kBAAkB;IAClB,yBD7F4B;IC8F5B,kBAAkB;IAClB,6BAA6B,EAAA;EAzFjC;IA6FI,6BAA6B;IAC7B,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB,EAAA;EAnGpB;IAuGI,yBD7G4B;IC8G5B,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,YAAY,EAAA;EA5GhB;IAgHI,gBAAgB,EAAA;EAhHpB;IAoHI,yBD1H4B;IC2H5B,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,gBAAgB;IAEhB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB,EAAA;EAnIpB;IAuII,gBAAgB,EAAA;EAvIpB;IA2II,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB,EAAA;EA/ItB;IAmJI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,aAAa,EAAA;EAtJjB;IA0JI,gCAAgC,EAAA;EA1JpC;IA8JI,yBAAyB,EAAA;EA9J7B;IAkKI,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,oBAAoB;IACpB,uBAAuB,EAAA;EAtK3B;IA0KI,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB,EAAA;EAhLtB;IAoLI,YAAY,EAAA;EApLhB;IAwLI,gBAAgB;IAChB,iBAAiB,EAAA;EAzLrB;IA6LI,cAAc,EAAA;EA7LlB;IAiMI,iBAAiB,EAAA;EAjMrB;IAqMI,yBAAyB,EAAA;EArM7B;IAyMI,yBAAyB,EAAA;EAzM7B;IA6MI,yBAAyB,EAAA;EA7M7B;IAiNI,YAAY,EAAA;EAjNhB;IAqNI,eAAe;IACf,WAAW;IACX,mBAAmB,EAAA;EAvNvB;IA2NI,YAAY;IACZ,iBAAiB,EAAA;EA5NrB;IAgOI,cAAc,EAAA;EAhOlB;IAoOI,uBAAuB;IAEvB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB,EAAA;EAzO7B;IA6OI,4BAA4B;IAC5B,WAAW,EAAA;EA9Of;IAkPI,aAAa,EAAA;EAlPjB;IAsPI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB,EAAA;EAvQtB;IA2QI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,mBAAmB,EAAA;EA9QvB;IAkRI,gBAAgB;IAChB,YAAY,EAAA;EAnRhB;IAuRI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB,EAAA;EAzRvB;IA6RI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,WAAW,EAAA;EApSf;IAwSI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,WAAW,EAAA;EAhTf;IAoTI,gBAAgB;IAChB,YAAY,EAAA;EArThB;IAyTI,YAAY;IACZ,gBAAgB,EAAA;EA1TpB;IA8TI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,cAAc,EAAA;EApUlB;IAwUI,sBAAsB,EAAA;EAxU1B;IA4UI,YAAY;IACZ,yBAAyB;IACzB,sBAAsB,EAAA;EA9U1B;IAkVI,sBAAsB;IACtB,oBAAoB,EAAA;EAnVxB;IAuVI,iGAAiG,EAAA;EAvVrG;IA2VI,iGAAiG,EAAA;EA3VrG;IA+VI,eAAe;IACf,eAAe;IACf,eAAe,EAAA;EAjWnB;IAsWI,YAAY,EAAA;EAtWhB;IA0WI,YAAY,EAAA;EA1WhB;IA8WI,aAAa;IACb,iBAAiB;IACjB,YAAY,EAAA;EAhXhB;IAoXI,kBAAkB;IAClB,WAAW,EAAA;EArXf;IAyXI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe,EAAA;EA5XnB;IAgYI,4BAA4B;IAC5B,WAAW,EAAA;EAjYf;IAqYI,yBD3Y4B;IC4Y5B,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAEhB,8BAA8B;IAC9B,sBAAsB,EAAA;EA/Y1B;IAmZI,gBAAgB;IAChB,YAAY,EAAA;EApZhB;IAwZI,yBD9Z4B;IC+Z5B,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY,EAAA;IA/ZhB;MAkaM,WD3aiB;MC4ajB,gBAtae;MAuaf,aAAa;MACb,gBAAgB,EAAA;MAratB;;;;;QA4aQ,kBAAkB;QAClB,aAAa;QACb,gBAjba,EAAA;MAGrB;QAkbQ,kCAvbuB;QAwbvB,iCAxbuB,EAAA;MAK/B;QAubQ,kCA5buB;QA6bvB,gCA7buB,EAAA;MAK/B;QA4bQ,gCAjcuB,EAAA;MAK/B;QAgcQ,yBDvbsB;QCwbtB,eAAe,EAAA;MAjcvB;QAqcQ,+BA1cuB,EAAA;MAK/B;QAycQ,kBAAkB,EAAA;MAzc1B;QA6cQ,mDAA+C;QAC/C,4BAA4B;QAC5B,wCAAwC,EAAA;MA/chD;QAmdQ,cD3doB;QC4dpB,mDAA6C;QAC7C,4BAA4B;QAC5B,wCAAwC,EAAA;EAtdhD;IA4dI,eAAe;IACf,iBAAiB;IACjB,kBAAkB,EAAA;IA9dtB;MAieM,aAAa;MACb,iBAAiB,EAAA;IAlevB;MAseM,yBAAyB,EAAA;EAte/B;IA2eI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,WAAW,EAAA;IAhff;MAmfM,sBAAsB;MACtB,aAAa;MACb,kBAAkB,EAAA;IArfxB;MAyfM,yBAAyB,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../../theme/_variables.scss\";\n\n$paddingLeftSize: 15px;\n$paddingTopSize: 10px;\n$tableDividerLineColor: #222224;\n$tableDividerLineBorderSize: 0.5px;\n$tableFontSize: 1.2vw;\n$positionTop: 140px;\n\n.risk-screening {\n  color: $primaryFontColor;\n  background-color: $containerScreenBackgroundColor;\n  height: 100vh;\n  width: 100%;\n  margin: 0px;\n  padding: 0px;\n  padding-left: $paddingLeftSize;\n  padding-right: $paddingLeftSize;\n  padding-top: $paddingTopSize;\n\n  .header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  h2 {\n    font-weight: 600;\n  }\n\n  .header-options-container {\n    width: auto;\n    display: flex;\n  }\n\n  .expand-container {\n    position: absolute;\n    top: 65px;\n    left: 70px;\n    height: 90vh !important;\n    width: calc(100% - 100px) !important;\n    z-index: 100;\n  }\n\n  .expand-container .table-container {\n    max-height: 80vh !important;\n  }\n\n  .fullscreen,\n  .more-options {\n    background-color: unset;\n    border: unset;\n\n    img {\n      filter: invert(1);\n    }\n  }\n\n  .fullscreen:hover {\n    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%);\n  }\n\n  .more-options:hover {\n    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%);\n  }\n\n  .container-row-top {\n    min-height: 40vh;\n    margin-top: 5px;\n  }\n\n  .container-row-bottom {\n    min-height: 40vh;\n    margin-top: 1px;\n  }\n\n  .column-chart {\n    margin-left: 10px;\n    max-width: 40%;\n  }\n\n  .chart-container {\n    height: 100%;\n    width: 100%;\n    width: -moz-available;\n    width: -webkit-fill-available;\n    width: stretch;\n    max-height: 50vh;\n  }\n\n  .chart-container-parent {\n    margin-left: 10px;\n  }\n\n  .chart-container {\n    position: relative;\n    background-color: $topMenuBackgroundColor;\n    border-radius: 2px;\n    box-shadow: 0px 0px 20px #000;\n  }\n\n  .expand-chart-container {\n    position: absolute !important;\n    top: 60px;\n    left: 95px;\n    height: 94vh !important;\n    width: 94% !important;\n    z-index: 100;\n    max-height: 94vh;\n  }\n\n  .map-report-container {\n    background-color: $topMenuBackgroundColor;\n    border-radius: 2px;\n    box-shadow: 0px 0px 20px #000;\n    display: flex;\n    position: relative;\n    height: 100%;\n  }\n\n  .column-summary {\n    min-width: 120px;\n  }\n\n  .summary-container {\n    background-color: $topMenuBackgroundColor;\n    border-radius: 2px;\n    box-shadow: 0px 0px 20px #000;\n    display: flex;\n    margin-top: 0px;\n    margin-left: 0px;\n\n    padding-top: 0px;\n    height: 24vh;\n    width: 120px;\n    min-width: 120px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    flex-direction: column;\n    border-radius: 7px;\n    max-height: 24vh;\n  }\n\n  .summary-container-secondary {\n    margin-top: 20px;\n  }\n\n  .summary-title {\n    display: flex;\n    width: 110px;\n    white-space: break-spaces;\n    text-align: center;\n    margin-bottom: 1px;\n  }\n\n  .summary-title Button {\n    display: none;\n    margin-left: 15px;\n    background-color: #fff;\n    border: unset;\n  }\n\n  .summary-title img {\n    vertical-align: unset !important;\n  }\n\n  .summary-title Button:hover {\n    background-color: #257ee0;\n  }\n\n  .summary-button {\n    display: none;\n    width: 44px;\n    display: inline-flex;\n    align-self: flex-end;\n    background-color: white;\n  }\n\n  .card {\n    padding-left: 2px;\n    width: 120px;\n    line-height: 18px;\n    padding-top: 5px;\n    margin-bottom: 10px;\n    max-width: 110px;\n    border-radius: 2px;\n  }\n\n  .card-header {\n    height: 37px;\n  }\n\n  .card-title {\n    line-height: 5px;\n    font-size: 1.2rem;\n  }\n\n  .card-body {\n    padding: .2rem;\n  }\n\n  .summary-container-span {\n    font-size: 1.2rem;\n  }\n\n  .te-primary {\n    background-color: #050e25;\n  }\n\n  .te-secondary {\n    background-color: #4fc32c;\n  }\n\n  .te-blue {\n    background-color: #0b61bf;\n  }\n\n  .summary-top {\n    width: 100px;\n  }\n\n  .summary-field-name {\n    font-size: 12px;\n    color: gray;\n    padding-bottom: 5px;\n  }\n\n  .summary-field-double {\n    height: auto;\n    line-height: 18px;\n  }\n\n  .summary-field-highlight {\n    color: #49b4cd;\n  }\n\n  .mapboxgl-popup-content {\n    padding: 0px !important;\n    ;\n    opacity: .95;\n    border-radius: 4px;\n    width: 100% !important;\n    background-color: #18244c;\n  }\n\n  .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {\n    border-bottom-color: #050E25;\n    opacity: .8;\n  }\n\n  .mapboxgl-popup-close-button {\n    display: none;\n  }\n\n  .popup-container {\n    background-color: black;\n    opacity: .95;\n    text-align: center;\n    height: 220px;\n    padding-top: 14px;\n    padding-bottom: 32px;\n    padding-left: 10px;\n    padding-right: 4px;\n    font-size: 14px;\n    font-size: 14px;\n    min-width: 210px;\n    line-height: 10px;\n    font-family: \"Urbanist\";\n    background-color: #050E25;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    width: max-content;\n  }\n\n  .popup-content-left {\n    text-align: right;\n    margin-right: 10px;\n    width: 75px;\n    white-space: normal;\n  }\n\n  .popup-content-right {\n    text-align: left;\n    width: 200px;\n  }\n\n  .popup-content-right-double {\n    height: 32px;\n    line-height: 18px;\n    margin-bottom: 25px;\n  }\n\n  .map-title {\n    width: auto;\n    white-space: nowrap;\n    position: absolute;\n    left: 50px;\n    top: 0px;\n    font-size: 1.25rem;\n    padding: 5px;\n    z-index: 90;\n  }\n\n  .map-legend {\n    width: 180px;\n    min-height: auto;\n    position: absolute;\n    border-radius: 5px;\n    padding: 5px;\n    right: 30px;\n    bottom: 10px;\n    background-color: #18244c;\n    z-index: 90;\n  }\n\n  .map-legend p {\n    margin-left: 5px;\n    height: 10px;\n  }\n\n  .map-legend span {\n    width: 100px;\n    margin-left: 5px;\n  }\n\n  .map-legend-dot {\n    background-color: #4b5ea6;\n    height: 14px;\n    width: 14px;\n    margin-left: 5px;\n    border-radius: 5%;\n    display: inline-flex;\n    color: #86b7fe;\n  }\n\n  .map-legend-accordion-header button {\n    border: 0px !important;\n  }\n\n  .accordion-button {\n    color: white;\n    background-color: #18244c;\n    border: 0px !important;\n  }\n\n  .accordion-button::after {\n    border: 0px !important;\n    filter: invert(100%);\n  }\n\n  .fullscreen:hover {\n    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%);\n  }\n\n  .more-options:hover {\n    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%);\n  }\n\n  .attribution-textbox {\n    margin-top: 3px;\n    font-size: 1rem;\n    text-align: end;\n  }\n\n\n  .line-chart {\n    height: 100%;\n  }\n\n  .line-chart canvas{\n    height: 100%;\n  }\n\n  .report-options-table {\n    width: 'auto';\n    margin-left: 10px;\n    height: 35px;\n  }\n\n  .report-options-table button {\n    position: absolute;\n    right: 30px;\n  }\n\n  .report-options-table-title {\n    text-align: left;\n    font-weight: 500;\n    vertical-align: sub;\n    font-size: 1rem;\n  }\n\n  .table-parent-container {\n    margin-left: 10px !important;\n    width: 100%;\n  }\n\n  .table-container {\n    background-color: $topMenuBackgroundColor;\n    border-radius: 2px;\n    box-shadow: 0px 0px 20px #000;\n    display: flex;\n    position: relative;\n    margin-top: 10px;\n    max-height: 36vh;\n    overflow-y: auto;\n    height: -moz-available;\n    height: -webkit-fill-available;\n    height: fill-available;\n  }\n\n  .reportTable {\n    min-height: 10vh;\n    color: white;\n  }\n\n  .table-parent-container {\n    background-color: $topMenuBackgroundColor;\n    border-radius: 2px;\n    box-shadow: 0px 0px 20px #000;\n    margin-top: 10px;\n    overflow-x: hidden;\n    margin-left: 20px;\n    overflow-y: hidden;\n    height: 40vh;\n\n    table {\n      color: $primaryFontColor;\n      font-size: $tableFontSize;\n      border: unset;\n      overflow-y: auto;\n\n      td,\n      tr,\n      th,\n      thead,\n      tbody {\n        font-weight: unset;\n        border: unset;\n        font-size: $tableFontSize;\n      }\n\n      thead>tr> :nth-child(1) {\n        border-bottom: $tableDividerLineBorderSize solid $tableDividerLineColor;\n        border-right: $tableDividerLineBorderSize solid $tableDividerLineColor;\n      }\n\n      thead>tr>th:not(:first-child) {\n        border-bottom: $tableDividerLineBorderSize solid $tableDividerLineColor;\n        border-left: $tableDividerLineBorderSize solid $tableDividerLineColor;\n      }\n\n      tbody>tr>td:not(:first-child) {\n        border-left: $tableDividerLineBorderSize solid $tableDividerLineColor;\n      }\n\n      tbody>tr:hover {\n        background-color: $inputBackgroundColor;\n        cursor: pointer;\n      }\n\n      tbody>tr>td.principal {\n        border-top: $tableDividerLineBorderSize solid $tableDividerLineColor;\n      }\n\n      .sub>td:nth-child(1) {\n        padding-left: 30px;\n      }\n\n      .principal {\n        background: url(../../../assets/arrow-down.svg);\n        background-repeat: no-repeat;\n        background-position: right 10px top 14px;\n      }\n\n      .principal.active {\n        color: $secundaryFontColor;\n        background: url(../../../assets/arrow-up.svg);\n        background-repeat: no-repeat;\n        background-position: right 10px top 14px;\n      }\n    }\n  }\n\n  .report-options {\n    margin-top: 2px;\n    text-align: right;\n    margin-right: 10px;\n\n    button {\n      border: unset;\n      margin-left: 10px;\n    }\n\n    .btn-light:hover {\n      background-color: #257ee0;\n    }\n  }\n\n  .report-chart-options {\n    margin-top: 2px;\n    text-align: right;\n    margin-right: 2px;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n\n    button {\n      background-color: #fff;\n      border: unset;\n      margin-left: 410px;\n    }\n\n    .btn-light:hover {\n      background-color: #257ee0;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
